// ----------------------------------------------------------------------------
// Section: Quiz Results
// ----------------------------------------------------------------------------
//
// Hidden until the Quiz Flow section on the same page dispatches
// "quiz:completed"; then reveals itself and activates the quiz-result block
// whose data-result-key matches the computed archetype. Also owns the share
// buttons (Facebook / X / copy link with toast) and the retake link.
//
// In the theme editor the section is always revealed (first result active,
// block selection switches the visible result) so it stays editable.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_quiz-results.scss';

// -------------------------------------
// Variables
// -------------------------------------

var RESULTS_SECTION = '.section--quiz-results';
var RESULTS_ROOT = '.js-quiz-results';
var RESULT = '.js-quiz-result';
var SHARE_BUTTON = '.js-quiz-share';
var RETAKE_BUTTON = '.js-quiz-retake';
var TOAST = '.js-quiz-toast';
var ACTIVE_CLASS = 'is-active';
var REVEALED_CLASS = 'is-revealed';
var TOAST_SHOW_CLASS = 'is-visible';
var TOAST_DURATION = 2200;
var STORAGE_PREFIX = 'sitka_quiz_';

// -------------------------------------
// Helper functions
// -------------------------------------

function activateResult(root, archetype) {
  var results = Array.prototype.slice.call(root.querySelectorAll(RESULT));
  if (results.length === 0) {
    return null;
  }
  var match = results.filter(function (result) {
    return result.dataset.resultKey === archetype;
  })[0] || results[0];
  results.forEach(function (result) {
    result.classList.toggle(ACTIVE_CLASS, result === match);
  });
  return match;
}
function reveal(sectionEl, root, archetype) {
  var match = activateResult(root, archetype);
  sectionEl.classList.add(REVEALED_CLASS);
  return match;
}
function showToast(root) {
  var toast = root.querySelector(TOAST);
  if (!toast) {
    return;
  }
  toast.classList.add(TOAST_SHOW_CLASS);
  window.clearTimeout(toast.dataset.timer);
  toast.dataset.timer = window.setTimeout(function () {
    toast.classList.remove(TOAST_SHOW_CLASS);
  }, TOAST_DURATION);
}
function share(root, network) {
  var active = root.querySelector(RESULT + '.' + ACTIVE_CLASS);
  var resultName = active ? active.dataset.resultName : '';
  var text = (root.dataset.shareText || '').replace('[result]', resultName);
  var url = window.location.href;
  if (network === 'facebook') {
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank', 'noopener,width=600,height=500');
  } else if (network === 'x') {
    window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url), '_blank', 'noopener,width=600,height=500');
  } else if (network === 'copy') {
    var done = function done() {
      showToast(root);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(done);
    } else {
      done();
    }
  }
}

// -------------------------------------
// Init
// -------------------------------------

function initResults(sectionEl) {
  var root = sectionEl.querySelector(RESULTS_ROOT);
  if (!root || root.dataset.quizInitialized) {
    return;
  }
  root.dataset.quizInitialized = 'true';
  var quizId = root.dataset.quizId || 'quiz';
  document.addEventListener('quiz:completed', function (event) {
    var profile = event.detail || {};
    if (profile.source && profile.source !== quizId) {
      return;
    }
    reveal(sectionEl, root, profile.archetype);
    sectionEl.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
  root.addEventListener('click', function (event) {
    var shareButton = event.target.closest(SHARE_BUTTON);
    if (shareButton) {
      share(root, shareButton.dataset.network);
      return;
    }
    if (event.target.closest(RETAKE_BUTTON)) {
      try {
        window.localStorage.removeItem(STORAGE_PREFIX + quizId);
      } catch (error) {
        // Storage unavailable — reloading still restarts the quiz
      }
      window.location.reload();
    }
  });

  // Keep the section visible and editable inside the theme editor
  if (window.Shopify && window.Shopify.designMode) {
    reveal(sectionEl, root, null);
    document.addEventListener('shopify:block:select', function (event) {
      if (!sectionEl.contains(event.target)) {
        return;
      }
      var result = event.target.closest(RESULT);
      if (result) {
        activateResult(root, result.dataset.resultKey);
      }
    });
  }
}
function initAll() {
  document.querySelectorAll(RESULTS_SECTION).forEach(function (sectionEl) {
    initResults(sectionEl);
  });
}
document.addEventListener('DOMContentLoaded', initAll);

// Re-init after the theme editor re-renders the section
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector && event.target.querySelector(RESULTS_ROOT)) {
    initAll();
  }
});